export default __webpack_public_path__ + "static/media/Borre.cacf04ad.jpg";